import React from "react";
import SEOLandingPage from "../../../components/tools/SEOLandingPage";

const NotabilityAlternative: React.FC = () => {
  return (
    <SEOLandingPage
      // SEO
      title="Best Notability Alternative 2025 - AI Note Taking App | YouWo AI"
      metaDescription="Looking for a Notability alternative with AI features? YouWo AI transcribes lectures, summarizes PDFs, and organizes notes automatically. Free AI-powered note taking."
      keywords="notability alternative, notability competitor, note taking app, ai notes, lecture recording app, goodnotes alternative, ipad notes app"
      canonicalUrl="https://youwo.ai/tools/notability-alternative"
      // Hero
      headline="AI-Powered Note Taking: The Smart Notability Alternative"
      subheadline="Take notes smarter, not harder. YouWo AI uses AI to transcribe lectures, summarize documents, and create study materials automatically."
      heroIcon="lucide:edit-3"
      heroIconColor="text-amber-500"
      heroIconBg="bg-amber-50"
      // Problem/Solution
      problemTitle="Traditional Note Taking Falls Short"
      problemDescription="With Notability, you still have to write everything yourself. Miss something in lecture? It's gone. Want to create flashcards? Manual work. Your notes stay static and hard to search."
      solutionTitle="AI That Takes Notes For You"
      solutionDescription="YouWo AI records and transcribes your lectures automatically. AI highlights key concepts, creates summaries, and generates flashcards. Your notes become active study tools."
      // Comparison
      competitorName="Notability"
      comparisonPoints={[
        { feature: "AI Transcription", youwoai: true, competitor: false },
        { feature: "Auto-Summarization", youwoai: true, competitor: false },
        { feature: "Flashcard Generation", youwoai: true, competitor: false },
        { feature: "Handwriting Support", youwoai: "Coming Soon", competitor: true },
        { feature: "Audio Recording", youwoai: true, competitor: true },
        { feature: "PDF Annotation", youwoai: true, competitor: true },
        { feature: "Cross-Platform", youwoai: true, competitor: "Apple Only" },
        { feature: "One-Time Purchase", youwoai: "Free Tier", competitor: "$15" },
      ]}
      // Features
      features={[
        {
          icon: "lucide:globe",
          title: "100+ Languages",
          description: "Transcribe and take notes in over 100 languages.",
        },
        {
          icon: "lucide:clock",
          title: "Clickable Timestamps",
          description: "Jump to any moment in your recording with clickable timestamps.",
        },
        {
          icon: "lucide:mic",
          title: "Live Transcription",
          description: "Record lectures and get accurate transcriptions with speaker identification.",
        },
        {
          icon: "lucide:layers",
          title: "Auto Flashcards",
          description: "Generate flashcards from your notes using active recall learning.",
        },
        {
          icon: "lucide:search",
          title: "Smart Search",
          description: "Search across all your notes, transcriptions, and documents instantly.",
        },
        {
          icon: "lucide:cloud",
          title: "Works Everywhere",
          description: "Access your notes on iOS, Android, and web - not just Apple devices.",
        },
      ]}
      // CTA
      ctaText="Try YouWo AI Free"
      ctaLink="https://apps.apple.com/app/youwo-ai-agent/id6760689478"
      // Related
      relatedTools={[
        { name: "Lecture Notes AI", href: "/tools/lecture-notes", icon: "lucide:graduation-cap" },
        { name: "Audio Transcriber", href: "/tools/audio-transcriber", icon: "lucide:mic" },
        { name: "PDF Summarizer", href: "/tools/pdf-summarizer", icon: "lucide:file-text" },
        { name: "AI Flashcard Maker", href: "/tools/flashcard-maker", icon: "lucide:layers" },
      ]}
    />
  );
};

export default NotabilityAlternative;
